const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
  state.paginacao = payload
}

const INSERIR_DISPONIBILIDADE_SELECIONADA = (state, payload) => {
  state.selecionado = payload
}

const INSERIR_LISTA_PROVEDORES = (state, payload) => {
  state.provedores = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    ATUALIZAR_PAGINACAO,
    INSERIR_DISPONIBILIDADE_SELECIONADA,
    INSERIR_LISTA_PROVEDORES,
}

